export default "__VITE_ASSET__CluxLbfO__"